import { render, staticRenderFns } from "./NotificationSubscriptionPurchase.vue?vue&type=template&id=83753534&scoped=true&"
import script from "./NotificationSubscriptionPurchase.vue?vue&type=script&lang=ts&"
export * from "./NotificationSubscriptionPurchase.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSubscriptionPurchase.vue?vue&type=style&index=0&id=83753534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83753534",
  null
  
)

export default component.exports